export default {
  text: '版权组件',
  // 在低代码平台展示的组件名称
  icon: 'http://simg01.gaodunwangxiao.com/uploadimgs/tmp/upload/202311/29/4b0a0_20231129092745.png',
  // 在低代码平台展示的组件图标
  name: 'SmCopyRight',
  // 固定
  group: '营销组件（不支持小程序）',
  sort: 1,
  // 排序
  schema: {
    /* 该配置用于描述该组件 */
    type: 'object',
    // 固定
    widget: 'SmCopyRight',
    // 该组件唯一标记，需要和导出组件名称一致，重要
    containerType: 'template',
    // 固定
    properties: {} // 固定
  },
  setting: {
    /* 该配置用于低代码平台右侧的属性配置 */
    props: {
      type: 'object',
      // 固定
      // title: '属性配置', // 固定
      widget: 'MEH5MarketingCopyRightSettingWidget'
    }
  }
};